module.exports = __webpack_public_path__ + "static/media/18ECA43.fc55afc8.jpg";